import React from 'react';
import MatchList from '../common/MatchList';

export default function LiveScores(props) {
  return (
    <MatchList
      {...props}
      subtitle="Live scores"
      emptyMessage="No matches available."
    />
  );
}
